import { Routes, Route, Navigate } from "react-router-dom";
import { Suspense } from "react";
import { Toaster } from "sonner";
import SignIn from "./pages/signin/page";
import SignUp from "./pages/signup/page";
import ShortStopAuthSuccess from "./pages/auth/success";
import ShortStopAuthFailure from "./pages/auth/failure";
import DesktopCallback from "./pages/auth/desktop-callback";
import MagicLogin from "./pages/auth/magic";
import ResetPassword from "./pages/reset-password/page";
import NewsletterConfirmation from "./pages/newsletter-confirmation/page";

function App() {
  console.log("app running");
  return (
    <>
      <Toaster
        position="top-right"
        richColors
        closeButton
        duration={4000}
        theme="dark"
        visibleToasts={3}
        expand={true}
        style={{
          fontSize: "14px",
          fontWeight: 500,
        }}
      />
      <Suspense fallback={<div>Loading...</div>}>
        <main
          style={{
            background: 'url("/images/DarkNoise.png") #231f20',
            backgroundSize: "50px auto",
          }}
          className="min-h-[100vh]"
        >
          <Routes>
            <Route path="/" element={<Navigate to="/signin" replace />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route
              path="/auth/success"
              element={<ShortStopAuthSuccess />}
            />
            <Route
              path="/auth/failure"
              element={<ShortStopAuthFailure />}
            />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/auth/desktop-callback" element={<DesktopCallback />} />
            <Route path="/auth/magic" element={<MagicLogin />} />
            <Route
              path="/newsletter-confirmation"
              element={<NewsletterConfirmation />}
            />
          </Routes>
        </main>
      </Suspense>
    </>
  );
}

export default App;
